var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9273 3.87969V3.23969C10.9273 2.3436 10.9273 1.89556 10.753 1.5533C10.5996 1.25224 10.3548 1.00747 10.0537 0.854077C9.71147 0.679688 9.26343 0.679688 8.36734 0.679688H7.08734C6.19126 0.679688 5.74322 0.679688 5.40096 0.854077C5.0999 1.00747 4.85513 1.25224 4.70173 1.5533C4.52734 1.89556 4.52734 2.3436 4.52734 3.23969V3.87969M6.12734 8.27969V12.2797M9.32734 8.27969V12.2797M0.527344 3.87969H14.9273M13.3273 3.87969V12.8397C13.3273 14.1838 13.3273 14.8559 13.0658 15.3693C12.8357 15.8209 12.4685 16.188 12.0169 16.4181C11.5035 16.6797 10.8315 16.6797 9.48734 16.6797H5.96734C4.62322 16.6797 3.95115 16.6797 3.43777 16.4181C2.98618 16.188 2.61902 15.8209 2.38893 15.3693C2.12734 14.8559 2.12734 14.1838 2.12734 12.8397V3.87969",
    stroke: "#CE3C25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.43183709f16859fb7034f32c19542180.svg";
export { ForwardRef as ReactComponent };